export default __webpack_public_path__ + "static/media/skyBoxUserImg.9cffee0f.svg";